import React from 'react';
import { MiniAppFocusWrapper } from 'src/components';
import { useIsMobile } from 'src/features/common/hooks/use-is-mobile';
import { Field } from 'formik';
import { SimpleWizardPageProps } from '../../../../common/components/simple-wizard/simple-wizard';
import { idMask, phoneNumberMaskSpaced } from '../../../../../helpers/formatting';
import { InputField, FormLayout, HeadingLayout, HeadingOne } from 'src/features/common';
import '../delivery-address-modal.scss';
import { BOUNDS } from 'src/features/onboarding/pages/business-details/resources/bounds';

export function ModalStepTwo(props: SimpleWizardPageProps) {
  return (
    <article className="ModalStepRevamp">
      <HeadingLayout
        renderMainHeading={() => (
          <HeadingOne>{`${
            props.brokerLogin ? '' : 'Now, '
          }Who will be receiving the delivery?`}</HeadingOne>
        )}
      />

      <section className="scrollable-area">
        <FormLayout>
          <Field
            name="receiverDetails.managerName"
            type="text"
            placeholder="Recipient full name"
            component={MiniAppFocusWrapper}
            innerComponent={InputField}
            fieldType="standard"
            className="top-field light"
            automationid={`${props.automationIdSuffix}_Step_Two_Recipient_Full_Name`}
            autoFocus={!useIsMobile()}
          />
          <Field
            name="receiverDetails.idNumber"
            type="tel"
            placeholder="Recipient ID number"
            component={MiniAppFocusWrapper}
            innerComponent={InputField}
            mask={idMask}
            guide={true}
            fieldType="masked"
            automationid={`${props.automationIdSuffix}_Step_Two_Recipient_ID_Number`}
            className="light"
          />
          <Field
            mask={phoneNumberMaskSpaced}
            id="phone_cell"
            name="receiverDetails.cellPhone"
            automationid={`${props.automationIdSuffix}_Step_Two_Recipient_Cell_Number`}
            placeholder="Recipient cell number"
            className="light"
            type="tel"
            guide={true}
            fieldType="masked"
            component={MiniAppFocusWrapper}
            innerComponent={InputField}
          />
          <Field
            mask={phoneNumberMaskSpaced}
            id="phone_work"
            name="receiverDetails.workPhone"
            automationid={`${props.automationIdSuffix}_Step_Two_Recipient_Work_Number`}
            placeholder="Recipient work number"
            className="light"
            type="tel"
            guide={true}
            fieldType="masked"
            component={MiniAppFocusWrapper}
            innerComponent={InputField}
          />
          <Field
            name="receiverDetails.tradingAs"
            type="text"
            placeholder="Trading name"
            component={MiniAppFocusWrapper}
            maxLength={BOUNDS.NAME_LENGTH}
            innerComponent={InputField}
            fieldType="standard"
            automationid={`${props.automationIdSuffix}_Step_Two_Trading_Name`}
            className="bottom-field light"
          />
        </FormLayout>
      </section>
    </article>
  );
}
